import React from 'react';
import { Radio, Zap, Activity } from 'lucide-react';

const RealTime: React.FC = () => {
  return (
    <div className='space-y-8'>
      <div>
        <h1 className='text-3xl font-bold text-gray-900'>Real-Time Streaming</h1>
        <p className='text-gray-600 mt-2'>
          Live data streaming with WebSocket support and real-time change tracking
        </p>
      </div>
      <div className='grid md:grid-cols-3 gap-6'>
        <div className='card'>
          <Radio className='w-8 h-8 text-red-600 mb-3' />
          <h3 className='text-lg font-semibold mb-2'>WebSocket Streams</h3>
          <button className='btn btn-primary w-full'>Connect Websocket</button>
        </div>
        <div className='card'>
          <Zap className='w-8 h-8 text-yellow-600 mb-3' />
          <h3 className='text-lg font-semibold mb-2'>Live Updates</h3>
          <button className='btn btn-secondary w-full'>Subscribe Updates</button>
        </div>
        <div className='card'>
          <Activity className='w-8 h-8 text-green-600 mb-3' />
          <h3 className='text-lg font-semibold mb-2'>Change Tracking</h3>
          <button className='btn btn-success w-full'>Track Changes</button>
        </div>
      </div>
      <div className='card'>
        <h3 className='text-2xl font-bold text-gray-900 mb-6'>Real-Time Demo</h3>
        <div className='bg-gray-50 rounded-lg p-6'>
          <p className='text-gray-600'>
            Real-time streaming demo will be shown here with WebSocket connections.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RealTime;
